export class SupplierInvoiceSaving {
  id: number;
  reductionTypeCode: string;
  lineNumber: number;
  amount: number;
  percentage: number;
  totalAmount: number | null;
  typedInField: string;
  gross: boolean;

  public constructor(init?: Partial<SupplierInvoiceSaving>) {
    Object.assign(this, init);
  }
}
